import EnumTranslations, {
    IGetEnumTranslationsOptions,
} from '@apigrowfinance/pbolt-enum-translation';

import enumMessages from '@messages/enumTranslations';

// Decorate enum util from pBolt by set the default messages to the enum messages in this mf
const getEnumTranslation = (
    key: string,
    options?: IGetEnumTranslationsOptions,
) => EnumTranslations(key, { messages: enumMessages, ...options });

export default getEnumTranslation;
